/* unplugin-vue-components disabled */import { render } from "./PostContent.vue?vue&type=template&id=54304f46&scoped=true"
import script from "./PostContent.vue?vue&type=script&lang=js"
export * from "./PostContent.vue?vue&type=script&lang=js"

import "./PostContent.vue?vue&type=style&index=0&id=54304f46&lang=scss&scoped=true"

import exportComponent from "/data/repos/231_20260522130100/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54304f46"]])

export default __exports__